"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./index.scss");
var Disclosures = function Disclosures(_ref) {
  var disclosureContent = _ref.disclosureContent;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "disclosures"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-12"
  }, /*#__PURE__*/_react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: disclosureContent.ALL_PROMOTIONAL_PLANS
    }
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-12"
  }, /*#__PURE__*/_react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: disclosureContent.PAYMENT_DETAIL_NO_INTEREST_PLAN
    }
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-12"
  }, /*#__PURE__*/_react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: disclosureContent.NO_INTEREST_PLAN
    }
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-12"
  }, /*#__PURE__*/_react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: disclosureContent.PAYMENT_DETAIL_PROMOTIONAL_RATE_PLAN
    }
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-12"
  }, /*#__PURE__*/_react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: disclosureContent.PROMOTIONAL_RATE_PLAN
    }
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-12"
  }, /*#__PURE__*/_react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: disclosureContent.DISCLAIMER
    }
  }))));
};
Disclosures.propTypes = {
  organization: _propTypes.default.string,
  constants: _propTypes.default.object,
  disclosureContent: _propTypes.default.object
};
Disclosures.defaultProps = {
  organization: 'Your Tuition Solution'
};
var _default = Disclosures;
exports.default = _default;
